/**
 * Global Privacy Control (GPC) detection shared across consent and acquisition.
 */
export function detectGpc(): boolean {
  if (typeof navigator === 'undefined') return false;
  return (navigator as Navigator & { globalPrivacyControl?: boolean }).globalPrivacyControl === true;
}
